import React from 'react';

import Table from './Partials/Table';

const Turns: React.FC = () => {
  return <Table />;
};

export default Turns;
